import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/admin/AdminUI";
import { Badge } from "@/components/ui/badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

const money = (v) => `₹${Number(v).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`;
const fmt = (ts) => {
  try {
    return new Date(ts).toLocaleDateString();
  } catch {
    return ts;
  }
};

export default function AdminInvoices() {
  const [inv, setInv] = useState(null);

  useEffect(() => {
    api.get("/admin/invoices").then((r) => setInv(r.data)).catch(() => setInv(false));
  }, []);

  if (inv === null)
    return <div className="flex h-64 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div>;
  if (inv === false) return <p className="text-sm text-destructive">Failed to load invoices.</p>;

  return (
    <div data-testid="admin-invoices">
      <PageHeader title="Invoices & GST" subtitle={`${inv.length} invoices · GST @ 18% (India)`} />
      <div className="overflow-x-auto rounded-2xl border border-border bg-card">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Invoice</TableHead>
              <TableHead>Customer</TableHead>
              <TableHead>GSTIN</TableHead>
              <TableHead className="text-right">Base</TableHead>
              <TableHead className="text-right">GST (18%)</TableHead>
              <TableHead className="text-right">Total</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Issued</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {inv.map((i, idx) => (
              <TableRow key={idx} data-testid={`invoice-row-${idx}`}>
                <TableCell className="font-mono text-xs">{i.number}</TableCell>
                <TableCell className="text-muted-foreground">{i.user_email}</TableCell>
                <TableCell className="font-mono text-xs text-muted-foreground">{i.gstin}</TableCell>
                <TableCell className="text-right">{money(i.base_amount)}</TableCell>
                <TableCell className="text-right text-muted-foreground">{money(i.gst_amount)}</TableCell>
                <TableCell className="text-right font-semibold">{money(i.amount)}</TableCell>
                <TableCell>
                  <Badge variant={i.status === "paid" ? "default" : "destructive"} className="capitalize">
                    {i.status}
                  </Badge>
                </TableCell>
                <TableCell className="text-muted-foreground">{fmt(i.issued_at)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
